import PropTypes from 'prop-types';

import { Select } from 'jl-design-system/components/select/Select';

import styles from './AddressDropdown.scss';

const constructDefaultOption = (addressCount, buildDefaultOptionLabel) => ({
  label:
    buildDefaultOptionLabel?.(addressCount) ??
    `Please select your address from ${addressCount} found:`,
  value: 'default',
  id: 'default',
  hidden: true,
  disabled: true,
});

const formatAddressSuggestions = (addressSuggestions) =>
  addressSuggestions.map((addressSuggestion) => ({
    id: addressSuggestion.id,
    value: JSON.stringify(addressSuggestion),
    label: addressSuggestion.description,
  }));

const getAddressesOptions = (addresses, buildDefaultOptionLabel) => {
  const addressesList = formatAddressSuggestions(addresses);
  return [constructDefaultOption(addressesList.length, buildDefaultOptionLabel), ...addressesList];
};

export const AddressDropdown = ({
  addresses,
  showAddressFormHandler,
  selectAddress,
  selectedAddress = '',
  buildDefaultOptionLabel = null,
  addressFormLinkLabel = null,
  children,
}) => (
  <div className={styles.AddressDropdown} data-testid="AddressDropdown">
    {children}
    <Select
      id="addressesDropdown"
      name="choseAddress"
      className={styles.AddressDropdown__select}
      onChange={selectAddress}
      value={selectedAddress}
      data-testid="SearchResults"
    >
      {getAddressesOptions(addresses, buildDefaultOptionLabel).map((option) => (
        <option
          key={option.id}
          value={option.value}
          hidden={option.hidden}
          disabled={option.disabled}
        >
          {option.label}
        </option>
      ))}
    </Select>
    <button
      className={styles.AddressDropdown__findBtn}
      type="button"
      onClick={showAddressFormHandler}
    >
      {addressFormLinkLabel ?? "I can't see my address in the list"}
    </button>
  </div>
);

AddressDropdown.propTypes = {
  addresses: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  children: PropTypes.node.isRequired,
  showAddressFormHandler: PropTypes.func.isRequired,
  selectAddress: PropTypes.func.isRequired,
  selectedAddress: PropTypes.string,
  addressFormLinkLabel: PropTypes.string,
  buildDefaultOptionLabel: PropTypes.func,
};
